/*
 * NYORD: Klicks der Warenkorb-Upsells (snippets/nb-wk-upsell, Zeilen aus snippets/nb-wk-up-eintrag, auch die
 * Bestseller im leeren Warenkorb).
 * „Zum Set wechseln“: Set in den Warenkorb, danach je ein Stück der enthaltenen Einzelteile heraus (Zeilenschlüssel
 * und Menge stehen in data-raus). „Hinzufügen“: gewählte Variante in den Warenkorb.
 * In der Seitenleiste wird die Section „cart-drawer“ neu gerendert wie bei Dawns Mengenänderung (cart.js), die neue
 * Zeile leuchtet golden auf (CSS nb-wk-neu aus nb-warenkorb.css); auf der Warenkorbseite lädt die Seite neu.
 */
(function () {
  if (window.nbUpsellBereit) return;
  window.nbUpsellBereit = true;

  function senden(url, daten) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten),
    }).then(function (antwort) {
      return antwort.json().then(function (json) {
        if (!antwort.ok || typeof json.status === 'number') throw new Error(json.description || antwort.status);
        return json;
      });
    });
  }

  function inLeiste(el) {
    return !!el.closest('cart-drawer');
  }

  // Zeilen außerhalb des Warenkorbs (Produktseite, „Passt dazu:“ in sections/main-product): Leiste neu rendern und
  // öffnen wie Dawns product-form, statt die Seite neu zu laden
  function oeffnetLeiste(el) {
    return !!el.closest('[data-nb-leiste-oeffnen]') && !!document.querySelector('cart-drawer');
  }

  function sektionen(knopf) {
    return inLeiste(knopf) || oeffnetLeiste(knopf)
      ? { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }
      : {};
  }

  function innen(html, selektor) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selektor);
    return el ? el.innerHTML : null;
  }

  function rendern(sections, variante, ansage) {
    var leiste = document.querySelector('cart-drawer');
    var alt = leiste && leiste.querySelector('.drawer__inner');
    var neu = sections && sections['cart-drawer'] && innen(sections['cart-drawer'], '.drawer__inner');
    if (alt && neu !== null) alt.innerHTML = neu;
    // Aus dem leeren Warenkorb (Bestseller) hinzugefügt: Leiste in den Zustand „gefüllt“ bringen wie Dawns product-form
    if (leiste && alt && alt.querySelector('.cart-item')) {
      leiste.classList.remove('is-empty');
      alt.classList.remove('is-empty');
    }
    var blase = document.getElementById('cart-icon-bubble');
    var blaseNeu = sections && sections['cart-icon-bubble'] && innen(sections['cart-icon-bubble'], '.shopify-section');
    if (blase && blaseNeu) blase.innerHTML = blaseNeu;
    if (!leiste) return;

    var zeile = null;
    leiste.querySelectorAll('.cart-item').forEach(function (z) {
      var link = z.querySelector('a[href*="variant="]');
      if (!zeile && link && link.getAttribute('href').indexOf('variant=' + variante) !== -1) zeile = z;
    });
    if (zeile) {
      zeile.classList.remove('nb-wk-neu');
      void zeile.offsetWidth;
      zeile.classList.add('nb-wk-neu');
      var name = zeile.querySelector('.cart-item__name');
      if (name) name.focus();
    }
    var region = leiste.querySelector('#CartDrawer-LiveRegionText');
    if (region && ansage) region.textContent = ansage;
  }

  // Nach einem Fehler den tatsächlichen Stand zeigen (z. B. Set drin, Einzelteile noch nicht raus)
  function neuLaden(knopf) {
    if (!inLeiste(knopf)) return window.location.reload();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        rendern(sections, '', '');
      });
  }

  function beschaeftigt(knopf, an) {
    knopf.disabled = an;
    knopf.setAttribute('aria-busy', String(an));
  }

  function fehler(knopf) {
    var box = knopf.closest('.nb-wk-upsell');
    var hinweis = box && box.querySelector('.nb-wk-up__fehler');
    beschaeftigt(knopf, false);
    if (hinweis) hinweis.hidden = false;
  }

  function fertig(knopf, json, variante) {
    if (inLeiste(knopf)) rendern(json.sections, variante, knopf.dataset.ansage);
    else if (oeffnetLeiste(knopf)) {
      rendern(json.sections, variante, knopf.dataset.ansage);
      beschaeftigt(knopf, false);
      var leiste = document.querySelector('cart-drawer');
      if (leiste && typeof leiste.open === 'function') leiste.open(knopf);
    } else window.location.reload();
  }

  function hinzufuegen(knopf) {
    beschaeftigt(knopf, true);
    var variante = knopf.dataset.id;
    senden(
      routes.cart_add_url + '.js',
      Object.assign({ items: [{ id: Number(variante), quantity: 1 }] }, sektionen(knopf))
    )
      .then(function (json) {
        fertig(knopf, json, variante);
      })
      .catch(function () {
        fehler(knopf);
      });
  }

  function tauschen(knopf) {
    beschaeftigt(knopf, true);
    var set = knopf.dataset.set;
    var updates = {};
    (knopf.dataset.raus || '').split(',').forEach(function (paar) {
      if (!paar) return;
      var teile = paar.split('|');
      updates[teile[0]] = Math.max(0, Number(teile[1]) - 1);
    });
    var setDrin = false;
    senden(routes.cart_add_url + '.js', { items: [{ id: Number(set), quantity: 1 }] })
      .then(function () {
        setDrin = true;
        return senden(routes.cart_update_url + '.js', Object.assign({ updates: updates }, sektionen(knopf)));
      })
      .then(function (json) {
        fertig(knopf, json, set);
      })
      .catch(function () {
        fehler(knopf);
        if (setDrin) neuLaden(knopf);
      });
  }

  function waehlen(wert) {
    if (wert.disabled) return;
    var eintrag = wert.closest('.nb-wk-up__eintrag');
    eintrag.querySelectorAll('.nb-wk-up__wert').forEach(function (w) {
      w.setAttribute('aria-pressed', String(w === wert));
    });
    eintrag.querySelector('[data-nb-dazu]').dataset.id = wert.dataset.id;
    var preis = eintrag.querySelector('[data-preis-neu]');
    if (preis) preis.textContent = wert.dataset.preis;
    var streich = eintrag.querySelector('.nb-wk-up__alt');
    if (streich) {
      streich.hidden = !wert.dataset.alt;
      streich.querySelector('[data-preis-alt]').textContent = wert.dataset.alt || '';
    }
    var rabatt = eintrag.querySelector('.nb-wk-up__rabatt');
    if (rabatt) {
      rabatt.hidden = !(Number(wert.dataset.rabatt) > 0);
      rabatt.querySelector('[data-rabatt-zahl]').textContent = wert.dataset.rabatt || '';
    }
    // Knapper Bestand je Variante; Text aus der Vorlage (Zahl fett), sonst ausblenden
    var bestand = eintrag.querySelector('.nb-wk-up__bestand');
    if (bestand) {
      var menge = Number(wert.dataset.bestand) || 0;
      bestand.hidden = menge === 0;
      if (menge > 0) bestand.querySelector('[data-bestand-text]').innerHTML = eintrag.dataset.bestandVorlage.replace('__N__', menge);
    }
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target.closest('.nb-wk-up__wert, [data-nb-dazu], [data-nb-set-tausch]');
    if (!ziel || ziel.disabled) return;
    e.preventDefault();
    if (ziel.classList.contains('nb-wk-up__wert')) waehlen(ziel);
    else if (ziel.hasAttribute('data-nb-dazu')) hinzufuegen(ziel);
    else tauschen(ziel);
  });
})();
